// extracted by mini-css-extract-plugin
module.exports = {"angle":"AngleSelector_angle__3sXdG","head":"AngleSelector_head__xTHtr"};